import React from "react";
import { GraduationCap } from "lucide-react";

const education = [
  {
    id: 1,
    title: "Diplomado en Desarrollo Web",
    institution: "Pontificia Universidad Católica de Chile",
    year: "2025",
    description:
      "Formación en principios y tecnologías de aplicaciones web modernas. Desarrollo full-stack con Python, JavaScript, React y arquitecturas de componentes.",
    skills: ["Python", "JavaScript", "React", "Desarrollo Web"],
    image: "/images/certificado desarrollo web.png",
    url: "https://www.credential.net/embed/e7a4bb96-8342-49bf-a746-c958275ed383",
  },
  {
    id: 2,
    title: "Curso Herramientas Básicas de Programación en Python",
    institution: "Pontificia Universidad Católica de Chile",
    year: "2025",
    description:
      "Programa introductorio sobre Python incluyendo conceptos básicos, control de flujo, estructuras de datos, funciones y procesamiento de datos con archivos .txt y .csv.",
    skills: [
      "Python",
      "Programación",
      "Ciencia de datos",
      "Solución algorítmica",
    ],
    image: "/images/certificado python.png",
    url: "https://www.credential.net/embed/8c76d06a-fecc-40b8-846b-d39ddcae1c62",
  },
];

const Education = () => {
  return (
    <section id="education" className="mb-10">
      <h2 className="text-2xl font-bold mb-6 text-dark flex items-center gap-2">
        <GraduationCap size={24} />
        Educación
      </h2>

      <div className="space-y-6">
        {education.map((edu) => (
          <div key={edu.id} className="bg-bg2 border border-dark/10">
            <div className="p-4 flex gap-4">
              <a
                href={edu.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0"
              >
                <img
                  src={edu.image}
                  alt={edu.title}
                  className="w-32 h-auto object-contain cursor-pointer hover:opacity-80 transition border border-black/10"
                />
              </a>
              <div className="flex-1">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-bold text-lg text-dark">{edu.title}</h3>
                    <p className="text-sm text-dark opacity-60">
                      {edu.institution}
                    </p>
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-wider text-accent bg-accent/10 px-2 py-1 rounded">
                    {edu.year}
                  </span>
                </div>

                <p className="text-sm text-dark opacity-80 mb-3">
                  {edu.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {edu.skills.map((skill, i) => (
                    <span
                      key={i}
                      className="text-[11px] font-semibold text-accent px-2 py-0.5 rounded bg-accent/5 border border-accent/20"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
